import { Text } from '@billy/design-system'

import { ShortcutKey } from '../../../../ShortcutKey'
import { Translate } from '../../../../Translate'
import * as Styled from './styles'

export const ResultsFooter = () => (
  <Styled.ResultsFooterWrapper>
    <Styled.ShortcursList>
      <Styled.ShortcutItem>
        <ShortcutKey icon="chevronUp" />
        <ShortcutKey icon="chevronDown" />
        <Styled.ShortcutLabelWrapper>
          <Text colorVariant="secondary">
            <Translate value="global_search.results_footer.to_navigate" />
          </Text>
        </Styled.ShortcutLabelWrapper>
      </Styled.ShortcutItem>

      <Styled.ShortcutItem>
        <ShortcutKey icon="undo" />
        <Styled.ShortcutLabelWrapper>
          <Text colorVariant="secondary">
            <Translate value="global_search.results_footer.to_select" />
          </Text>
        </Styled.ShortcutLabelWrapper>
      </Styled.ShortcutItem>

      <Styled.ShortcutItem>
        <ShortcutKey label="esc" />
        <Styled.ShortcutLabelWrapper>
          <Text colorVariant="secondary">
            <Translate value="global_search.results_footer.to_dismiss" />
          </Text>
        </Styled.ShortcutLabelWrapper>
      </Styled.ShortcutItem>
    </Styled.ShortcursList>
  </Styled.ResultsFooterWrapper>
)
